/**
 * Хайлтын системд зориулсан robots metadata.
 * Dashboard-ийн robotsIndex/robotsFollow-ээс хамаарахгүй, үргэлж тогтмол.
 */
export const searchEngineRobots = {
  index: true,
  follow: true,
  googleBot: {
    index: true,
    follow: true,
    "max-video-preview": -1,
    "max-image-preview": "large",
    "max-snippet": -1,
  },
};

/** Хайлтын үр дүн, хувийн хуудас зэрэгт — индекслэхгүй, холбоос дагана */
export const searchEngineRobotsNoindex = {
  index: false,
  follow: true,
  googleBot: {
    index: false,
    follow: true,
  },
};

export function withSearchEngineRobots(metadata, { index = true } = {}) {
  return {
    ...metadata,
    robots: index ? searchEngineRobots : searchEngineRobotsNoindex,
  };
}
